import { RouteMatcher } from "@faire/web/common/routes/RouteMatcher";
import { route as boardsRoute } from "@faire/web-api--source/routes/www/boards";
import { route as categoryRoute } from "@faire/web-api--source/routes/www/category/c1CategoryUrlId";
import { route as myBrandsRoute } from "@faire/web-api--source/routes/www/my-brands";
import { route as productRoute } from "@faire/web-api--source/routes/www/product/productToken";
import { route as homeRoute } from "@faire/web-api--source/routes/www/root";
import { route as searchRoute } from "@faire/web-api--source/routes/www/search";

const ELIGIBLE_PAGES = [
  homeRoute,
  searchRoute,
  categoryRoute,
  productRoute,
  boardsRoute,
  myBrandsRoute,
];

export const isPathEligibleForShopifyNudge = (pathName: string) => {
  const matcher = new RouteMatcher(ELIGIBLE_PAGES);
  return !!matcher.match(pathName);
};
